// Import Sentry for issue tracking
import * as Sentry from '@sentry/vue'
// Import Framework7-Vue Plugin
import Framework7Vue, { registerComponents } from 'framework7-vue/bundle'
// Import Framework7
import Framework7 from 'framework7/lite-bundle'
// Import Vue
import { createApp } from 'vue'
// Import Framework7 Styles
import 'framework7/css/bundle'

// Import Icons and App Custom Styles
import '@/css/app.scss'
import '@/css/icons.css'

import { createTelemetryOptions } from '@/assets/composables/telemetry'
// Import App Component
import App from '@/components/app.vue'

// Init Framework7-Vue Plugin
Framework7.use(Framework7Vue)

// Init App
const app = createApp(App)

// Register Framework7 Vue components
registerComponents(app)

Sentry.init({
  ...createTelemetryOptions(import.meta.env.MODE, import.meta.env.PROD),
  app,
})

// Mount the app
app.mount('#app')
